// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__p4kWE","link":"Breadcrumbs_link___0x9B","notActive":"Breadcrumbs_notActive__k1Oso"};